import React from 'react';
import Dropzone from 'react-dropzone';

const FileInput = (props) => {
    return (
        <div>
            <Dropzone
                {...props}
                onDrop={files => {return props.multiple ? props.input.onChange(files) : props.input.onChange(files[0])}}
                onBlur={event => event.preventDefault()}
                className="dropzone-format"
                multiple={props.multiple}
            >
                <div style={{textAlign: "center", top: "45%", position: "relative"}}>Drag File here or...</div>
                <button type="button" style={{margin: "0 auto", display: "block", position: "relative", top: "110px"}} className="btn btn-sm btn-default">Select File</button>
            </Dropzone>
            {props.meta.touched && ((props.meta.error && <span className="input-error">{props.meta.error}</span>) )}
        </div>
    );
}

export default FileInput;